jQuery(document).ready(function ($) {
    $(document).on('click', '.ginput_container_select select', function () {
        $(this).addClass('clicked');
    });
});
